import React, { Component } from "react";
import { langCheck, imLogin } from "Pub/js/utils";
import "./index.less";
import HotKeyNCModal from "Components/HotKeysModal/HotKeyNCModal";
import platform from "Pub/js/platform";
const { PubSub, reloadAjax } = platform;
const { NCModal, NCButton, NCTooltip, NCHotKeys } = platform.base;
import WidgetJSLoader from "Pages/NewHome/CreaterForWidget/WidgetJSLoader";
import { setStore, getStore } from "../../pub/js/storageUtils";

class ControlBox extends Component {
    constructor(props) {
        super(props);
        this.state = {
            visible: true,
            initLoginPage: null // 调出登录组件的方法
        };
    }
    componentDidMount() {
        this.props.redirectLoginFunc && WidgetJSLoader('/nccloud/resources/uap/rbac/login/loginComponent/index.js', key => {
            this.setState({
                initLoginPage: window[key].default
            })
        });
    }
    /* 取消按钮事件 */
    handleCancel = () => {
        if (
            this.props.cancelClick &&
            typeof this.props.cancelClick === "function"
        ) {
            this.props.cancelClick();
        }
        this.setState({ visible: false });
        this.close();
    };
    //删除弹框
    close = () => {
        let element = document.getElementsByClassName("prompt-project")[0];
        if (element) {
            ReactDOM.unmountComponentAtNode(element);
            clearTimeout(this.closeTimer);
            this.closeTimer = null;
            document.body.removeChild(element);
        }
    };
    //确认按钮事件
    handleOk = () => {
        if (this.props.okClick && typeof this.props.okClick === "function") {
            this.props.okClick();
        }
        this.setState({ visible: false });
        this.close();
    };
    handleDirectLogin = () => {
        const { initLoginPage } = this.state;
        const { container } = this.props;
        const modalContainer = container.querySelector('.prompt-box-project');
        const loginContainer = <div className="prompt-direct-login"></div>;
        ReactDOM.render(loginContainer, modalContainer, () => {
            initLoginPage({
                container: modalContainer.querySelector('.prompt-direct-login'),
                loginCallBack: () => {
                    localStorage.removeItem("NCC_IMData");
                    imLogin();
                    PubSub.publish('reloadAppData', () => {
                        this.handleCancel();
                        reloadAjax();
                        const iframes = document.querySelectorAll('#mainiframe');
                        iframes.forEach(item => {
                            if (item.contentWindow) {
                                const contentPlatform = item.contentWindow['nc-lightapp-front'];
                                if (contentPlatform) {
                                    contentPlatform.reloadAjax && contentPlatform.reloadAjax();
                                }
                            }
                        })
                    });
                },
                goLogin: this.props.redirectLoginFunc
            });
        });
    }
    render() {
        const { msg, toastIcon, container, ...others } = this.props;
        const { okText, cancelText, zIndex } = others;
        const { initLoginPage } = this.state;
        return (
            <HotKeyNCModal
                container={container}
                className={`prompt-box-project ${others.className || ''}`}
                show={this.state.visible}
                width={410}
                minHeight={210}
                size="sm"
                style={{ top: 50 }}
                backdropClosable={false}
                draggable={false}
                // resizable={false}
                fieldid={this.props.fieldid}
                zIndex={zIndex}
                onOk={this.handleOk}
                onCancel={this.handleCancel}
                onHide={this.handleCancel}
                keyboard={true}
                dialogClassName="prompt-box-dialog"
            >
                <NCModal.Header>
                    <NCModal.Title>{langCheck("0000PUB-000257")}</NCModal.Title> {/* 国际化处理： 提示消息*/}
                </NCModal.Header>
    
                <NCModal.Body>
                    {toastIcon}
                    <p className="prompt-content">{msg}</p>
                </NCModal.Body>
                <NCModal.Footer>
                    {
                        this.props.isOkBtn && (
                            <NCTooltip
                                placement="top"     
                                overlay={`${okText || langCheck("0000PUB-000001")}(Alt + Y)`} 
                            >
                                <NCButton 
                                    colors="primary" 
                                    fieldid="confirm" 
                                    onClick={this.handleOk}
                                >
                                    {okText || langCheck("0000PUB-000001")}{/* 国际化处理： 确定*/}
                                (<span className="underline">Y</span>)
                                </NCButton>
                            </NCTooltip>
                        )
                    }
                    {
                        this.props.isCancelBtn && (
                            <NCTooltip
                                placement="top"
                                overlay={`${cancelText || langCheck("0000PUB-000000")}(Alt + N)`} 
                            >
                                <NCButton fieldid="cancel" onClick={this.handleCancel}>
                                    {cancelText || langCheck("0000PUB-000000")}{/* 国际化处理： 取消*/}
                                    (<span className="underline">N</span>)
                                </NCButton>
                            </NCTooltip>
                        )
                    }
                    {
                        initLoginPage && <React.Fragment>
                            <div className="direct-login" ref={ref => this.directLoginRef = ref}></div>
                            <NCTooltip
                                placement="top"
                                overlay={`${langCheck("0000PUB-000657")}(Alt + R)`}
                                getPopupContainer={() => container.querySelector('.prompt-box-dialog')}
                            >
                                <NCButton onClick={this.handleDirectLogin}>
                                    <NCHotKeys
                                        keyMap={{
                                            loginHandle: ['Alt+R']
                                        }}
                                        handlers={{
                                            loginHandle: this.handleDirectLogin
                                        }}
                                        focused={true}
                                    />
                                    {langCheck('0000PUB-000657')}
                                    (<span className="underline">R</span>)
                                </NCButton>
                            </NCTooltip>
                        </React.Fragment>
                    }
                </NCModal.Footer>
            </HotKeyNCModal>
        );
    }
}
export default ControlBox;